import MiniDateStamp from "src/components/atoms/MiniDateStamp";
import EventDetailsList from "src/components/molecules/EventDetailsList";
import FilledImage from "src/components/molecules/FilledImage";
import AdaptiveEventImage from "../../molecules/AdaptiveEventImage";

const SearchResult = ({ event }) => {
	return (
		<div className="w-full m-0 py-3 @lg:my-2 @lg:py-2 text-base px-3 cursor-pointer active:bg-gray-100">
			<div className="relative">
				<div className="flex flex-row overflow-hidden text-xs">
					<div className="relative pb-16 overflow-hidden w-42 h-24 flex-none rounded image-placeholder p-0 border">
						<div className="absolute top-0 z-30">
							<MiniDateStamp event={event} mini />
						</div>
						{event.imageThumbUrl && (
							<AdaptiveEventImage
								src={event.imageThumbUrl}
								alt={event.title}
								className="absolute inset-0 h-full w-full object-cover"
								loading="eager"
							/>
						)}
					</div>
					<div className="pt-0 relative">
						<h3 className="text-primary-800 font-semibold text-base ml-2 @md:ml-5 -mt-1">
							{event.title}
						</h3>
						<EventDetailsList event={event} isSearchResult />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SearchResult;
